import { Text } from '@change/ds-core-ui';

import { TranslateHtml, TranslatePluralHtml } from '@change-corgi/core-react/i18n';

import { useHomepagePageData } from 'src/app/pages/homepage/pageContext';

export const TitleAndTagline: React.FC = () => {
	const {
		data: { totalUserCount },
	} = useHomepagePageData();

	return (
		<>
			<Text data-testid="homepage-hero-heading" variant="display" as="h1" className="text-center md:text-[80px]">
				<TranslateHtml value="corgi.homepage.hero_sunrise.title" />
				<span className="text-typography-brand">.</span>
			</Text>

			<Text
				as="p"
				variant="heading"
				size="medium"
				fontWeight="light"
				className="mx-auto max-w-[400px] text-center xl:max-w-[640px]"
				data-testid="homepage-hero-tagline"
			>
				<TranslatePluralHtml
					value="corgi.homepage.hero_sunrise.tagline"
					count={totalUserCount.total}
					replacements={{ userCount: totalUserCount.totalLocalized }}
				/>
			</Text>
		</>
	);
};
